import { createEvent, createStore } from 'effector';
import { TooltipState } from '../model';

export const update = createEvent<TooltipState>();
export const $tooltip = createStore<TooltipState | null>(null).on(
  update,
  (_, state) => state
);
